import React, { useState, useEffect } from "react";
import About from "../../assets/img/about.webp";
import kunalIntro from "../../assets/videos/kunal-intro.mp4";
import kunalIntroMobile from "../../assets/videos/kunal_intro_mobile.mp4";
import playButton from "../../assets/img/play-button.svg";
import { useInView } from "react-intersection-observer";
import "animate.css";
import { useNav } from "../../context/nav-context";
const Service = () => {
  const [video, setVideo] = useState(false);
  const [videoSrc, setVideoSrc] = useState(""); // State for video source
  const [ref, inView] = useInView({
    triggerOnce: false, // Trigger animations each time the element comes into view
    threshold: 0.2, // Trigger when 20% of the component is visible
  });
  const { setActiveLink } = useNav();
  // Update activeLink to "journey" when this section is in view
  useEffect(() => {
    if (inView) {
      setActiveLink("whyus");
    }
  }, [inView, setActiveLink]);
  // Set video source based on screen size
  useEffect(() => {
    const updateVideoSrc = () => {
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      setVideoSrc(
        isMobile
          ? kunalIntroMobile // Mobile video URL
          : kunalIntro // Desktop video URL
      );
    };

    updateVideoSrc(); // Set initial video source
    window.addEventListener("resize", updateVideoSrc); // Update on resize

    return () => {
      window.removeEventListener("resize", updateVideoSrc);
    };
  }, []);
  return (
    <div id="WhyUs">
      <div ref={ref} className="container mt-3 mb-5">
        <h2
          className={`text-center py-3 fs-46 fw-400 mb-3 ${
            inView
              ? "animate__animated animate__zoomIn"
              : "animate__animated animate__zoomOut"
          }`}
        >
          Clinically Led Teeth Straightening -{" "}
          <span className="text-yellow">Everytime</span>
        </h2>

        <div className="row g-0">
          <div className="col-lg-7">
            <div className="video-img-div rounded-4 ">
              {video ? (
                <iframe
                  src={videoSrc}
                  className="h-100 w-100 mb-4 position-relative rounded-4"
                />
              ) : (
                <div className="position-relative h-100">
                  <img
                    src={About}
                    className={`w-100 h-100 mb-4 object-fit-cover ${
                      inView
                        ? "animate__animated animate__zoomIn"
                        : "animate__animated animate__zoomOut"
                    }`}
                  />
                  <div className="position-absolute top-0 left-0 w-100 h-100 d-flex justify-content-center z-2 align-items-center">
                    <button
                      className="p-0 bg-transparent border-0"
                      onClick={() => setVideo(true)}
                    >
                      <img
                        src={playButton}
                        alt="play button"
                        style={{ width: "100px", height: "100px" }}
                      />
                    </button>
                  </div>
                </div>
              )}
            </div>
            {/* <img
              src={About}
              className={`img-fluid mb-4 rounded-4 ${
                inView
                  ? "animate__animated animate__zoomIn"
                  : "animate__animated animate__zoomOut"
              }`}
            /> */}
          </div>
          <div className="col-lg-5 d-flex align-items-end">
            <div className="card border-0 shadow rounded-3 choose-us-card">
              <div className="card-body p-4 text-center text-lg-start">
                <div
                  className={`card-title fs-34 ${
                    inView
                      ? "animate__animated animate__zoomIn"
                      : "animate__animated animate__zoomOut"
                  }`}
                >
                  Why Choose Us
                </div>
                <p
                  className={`fs-17 fw-300 ${
                    inView
                      ? "animate__animated animate__zoomIn"
                      : "animate__animated animate__zoomOut"
                  }`}
                >
                  With Alignar we push the boundaries in clear aligner
                  technology, but we still make sure the most important part of
                  the process is done the traditional way by ensuring every case
                  is reviewed and planned by an orthodontist - not a computer.
                  AI has revolutionised a lot of what we do but planning how to
                  move your teeth is one area we don’t think it's ready to
                  intervene in yet.
                  <br />
                  <br />
                  Prioritising safe tooth movement with the very best aligner
                  materials leads to more predictable treatments with less
                  refinements, lowers the risk of damaging the bone supporting
                  the teeth, and contributes to long-term success.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
